import { SidebarItemsModelV } from '../components/companyMenu/sidebarItemsModel';
import {
  Building24Regular,
  LockClosedKey24Regular,
  Person24Regular,
  PeopleTeam24Regular,
  Grid24Regular,
  ReceiptMoney24Regular,
} from '@fluentui/react-icons';
import { PermissionObject } from '@jaam/commons/constants';

const COMPANY_ITEMS = [
  {
    action: 'view',
    code: 'info',
    path: '/company/information',
    name: PermissionObject.COMPANY,
    icon: Building24Regular, // Use Fluent UI icon
  },
  {
    action: 'update',
    code: 'members',
    path: '/company/members',
    name: PermissionObject.COMPANY,
    icon: Person24Regular, // Use Fluent UI icon
  },
  {
    action: 'view',
    code: 'teams',
    name: PermissionObject.TEAM,
    path: '/company/teams',
    icon: PeopleTeam24Regular, // Use Fluent UI icon
  },
  {
    action: 'update',
    code: 'plan',
    name: PermissionObject.PLAN,
    path: '/company/plan',
    icon: ReceiptMoney24Regular, // Use Fluent UI icon
  },
  {
    action: 'view',
    code: 'payroll_elements',
    name: PermissionObject.PAYROLL_ELEMENT,
    path: '/company/payroll-elements',
    icon: Grid24Regular, // Use Fluent UI icon
  },
  {
    action: 'view',
    code: 'credentials',
    name: PermissionObject.CREDENTIAL,
    path: '/company/credentials',
    icon: LockClosedKey24Regular,
  },
] as SidebarItemsModelV[];

export default COMPANY_ITEMS;
